
export class FooterMenuAccordion {
    constructor (selectors) {
        this.accordions = document.querySelectorAll(selectors);
        this.init();
    }

    init() {
        if (this.accordions.length < 1) {
            return;
        }

        [].forEach.call(this.accordions, (item) => {
            this.listenClick(item);
            this.listenKeyDown(item);
        });
    }

    listenClick(item) {
        item.addEventListener('click', (event) => {
            event.preventDefault();

            this.toggleVisible(item);
        });

    }

    listenKeyDown(item) {
        item.addEventListener('keydown', (event) => {
            // "Spacebar" for IE11 support
            if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
                event.preventDefault();

                this.toggleVisible(item);
            }
        });
    }

    toggleVisible(item) {
        const container = item.parentElement;
        const type = item.getAttribute('data-accordion-type');
        const suffixModification = type ? type : '--open';

        container.classList.toggle( 'footer-nav__column' + suffixModification);
    }
}

// TODO: accessibility https://www.wrike.com/open.htm?id=493735901



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/footer/footer.js